module.exports = __webpack_public_path__ + "media/images/home-page/3-4-3f56ec520e22da469478581c1a31740a.png";